/** After selecting a tree node: show detail from the top; on stacked layout bring it into view. */
export function resetHierarchyDetailScroll(
  el: {
    scrollTo: (options?: ScrollToOptions) => void
    scrollIntoView: (arg?: boolean | ScrollIntoViewOptions) => void
  } | null,
  narrowViewport: boolean,
): void {
  if (!el) return
  el.scrollTo({ top: 0 })
  if (narrowViewport) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
